import clsx from 'clsx';

export type ConnectionState = 'connected' | 'reconnecting' | 'disconnected';

export function LiveStatusDot({ state }: { state: ConnectionState }) {
  const color =
    state === 'connected'
      ? 'bg-accent-green'
      : state === 'reconnecting'
      ? 'bg-accent-yellow'
      : 'bg-accent-red';

  return (
    <span className="relative inline-flex h-2 w-2 items-center justify-center">
      {state !== 'disconnected' && (
        <span
          className={clsx('absolute inline-flex h-full w-full rounded-full opacity-50', color, 'animate-ping')}
          style={{ animationDuration: '1500ms' }}
        />
      )}
      <span className={clsx('relative inline-flex h-2 w-2 rounded-full', color)} />
    </span>
  );
}
